import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import messages from './cookiesOverlay.messages';
import { Markdown, ContentWrapper as Content } from './cookiesOverlay.styles';
import { Overlay } from '../overlay';
import { AnimatedOverlay } from '../animatedOverlay';

export class CookiesOverlay extends PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    isVisible: PropTypes.bool,
    isStandalone: PropTypes.bool,
    content: PropTypes.string,
    fetchCookies: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.fetchCookies();
  }

  render() {
    const {
      isStandalone,
      isVisible,
      content,
      intl: { formatMessage },
    } = this.props;
    return (
      <Fragment>
        <AnimatedOverlay visible={isVisible} disableAnimation={isStandalone}>
          <Overlay title={formatMessage(messages.title)}>
            <Content>
              <Markdown>{content}</Markdown>
            </Content>
          </Overlay>
        </AnimatedOverlay>
      </Fragment>
    );
  }
}
